import { styled } from "@mui/material";
import { useBreakpoints } from "../hooks/BreakpointsHook";
import pic from "../image1.png";
import React, { useState } from 'react';

const BottomContainer = styled("div")((props) => ({
    display: "flex",
    flexDirection: props.isMd || props.isSm || props.isXs ? "column" : "row",
    alignItems: props.isMd || props.isSm || props.isXs ? "center" : "stretch",
    //height: "100%",
    width: "100%",
    boxSizing: 'border-box',
    padding: props.isMd || props.isSm || props.isXs ? "0px 50px" : "0px 170px",
    borderTop: "1px solid rgba(0, 0, 0, 0.20)",
    background: "#000",  // Set the background to black
    flex: "0 0 auto",  // Don't grow, don't shrink, auto base size
}));




const ContentContainer = styled("div")({
    flex: 1,
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    padding: "20px",
    width: "100%",
    background: "#000",
});

const Title = styled("h2")({
    color: "#FFF",  // Set text color to white
    textAlign: "center",
    fontFamily: "Roboto",
    fontSize: "15px",
    fontStyle: "normal",
    fontWeight: 400,
    lineHeight: "28px",  // 140%
    alignSelf: "stretch",
    margin: "0",  // Set margin to zero
    background: "#000",
});

const SmallerContainer = styled("div")({
    display: "flex",
    paddingTop: "20px",
    alignItems: "flex-start",
    alignContent: "flex-start",
    alignSelf: "stretch",
    flexWrap: "wrap",
    background: "#FFF",
    background: "#000",
    // Add any other styles for the SmallerContainer here
});


const EmailInput = styled("input")({
    display: "flex",
    height: "36px",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    gap: "4px",
    flex: "1 0 0",
    padding: "0",
    textAlign: "center",
    border: "1px solid #000",  // Add a border
    outline: "none",  // Remove focus outline
    boxSizing: "border-box",  // Ensure padding and border are included in the total height
    // Add any other styles for the input box here
});




export default function Bottom() {
    const { isXs, isSm, isMd, isLg, isXl } = useBreakpoints();

    return (
        <BottomContainer isXs={isXs} isSm={isSm} isMd={isMd} isLg={isLg} isXl={isXl}>
            
            <ContentContainer>
                <Title>© 2023 Bolt Finance. All rights reserved.</Title>
            </ContentContainer>
        </BottomContainer>
    );
}
